// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__wZFB4","savePackageButton":"ClientWallet_savePackageButton__p0wa-"};